export enum TipoDescontoCalculo {
  Porcentagem = 0,
  Valor = 1
}
